// Language flag mapping
export const LANGUAGE_FLAGS = {
  // Main languages
  'English': '🇬🇧',
  'Spanish': '🇪🇸',
  'French': '🇫🇷',
  'German': '🇩🇪',
  'Italian': '🇮🇹',
  'Russian': '🇷🇺',
  'Chinese': '🇨🇳',
  'Japanese': '🇯🇵',
  'Korean': '🇰🇷',
  'Arabic': '🇸🇦',
  'Portuguese': '🇵🇹',
  'Dutch': '🇳🇱',
  'Greek': '🇬🇷',
  'Hebrew': '🇮🇱',
  'Hindi': '🇮🇳',
  'Turkish': '🇹🇷',
  'Polish': '🇵🇱',
  'Ukrainian': '🇺🇦',
  'Swedish': '🇸🇪',
  'Norwegian': '🇳🇴',
  'Danish': '🇩🇰',
  'Finnish': '🇫🇮',
  'Vietnamese': '🇻🇳',
  
  // Language codes (for ProgressPill)
  'en': '🇬🇧',
  'es': '🇪🇸',
  'fr': '🇫🇷',
  'de': '🇩🇪',
  'it': '🇮🇹',
  'ru': '🇷🇺',
  'zh': '🇨🇳',
  'ja': '🇯🇵',
  'ko': '🇰🇷',
  'ar': '🇸🇦',
  'pt': '🇵🇹',
  'nl': '🇳🇱',
  'el': '🇬🇷',
  'he': '🇮🇱',
  'hi': '🇮🇳',
  'tr': '🇹🇷',
  'pl': '🇵🇱',
  'uk': '🇺🇦',
  'sv': '🇸🇪',
  'no': '🇳🇴',
  'da': '🇩🇰',
  'fi': '🇫🇮',
  'vi': '🇻🇳',
  
  // Default
  'default': '🌐'
};

// Helper function to get flag from language name or code
export const getLanguageFlag = (language) => {
  if (!language) return LANGUAGE_FLAGS.default;
  
  // Try exact match first
  if (LANGUAGE_FLAGS[language]) {
    return LANGUAGE_FLAGS[language];
  }
  
  // Try case-insensitive match
  const lowerLang = language.toLowerCase();
  for (const [key, flag] of Object.entries(LANGUAGE_FLAGS)) {
    if (key.toLowerCase() === lowerLang) {
      return flag;
    }
  }
  
  // Try matching by first word (for "English_US" -> "English")
  const firstWord = language.split('_')[0]?.split(' ')[0];
  if (firstWord && LANGUAGE_FLAGS[firstWord]) {
    return LANGUAGE_FLAGS[firstWord];
  }
  
  return LANGUAGE_FLAGS.default;
};

// Get language name from code
export const getLanguageNameFromCode = (code) => {
  const codeToName = {
    'en': 'English',
    'es': 'Spanish',
    'fr': 'French',
    'de': 'German',
    'it': 'Italian',
    'ru': 'Russian',
    'zh': 'Chinese',
    'ja': 'Japanese',
    'ko': 'Korean',
    'ar': 'Arabic',
    'pt': 'Portuguese',
    'nl': 'Dutch',
    'el': 'Greek',
    'he': 'Hebrew',
    'hi': 'Hindi',
    'tr': 'Turkish',
    'pl': 'Polish',
    'uk': 'Ukrainian',
    'sv': 'Swedish',
    'no': 'Norwegian',
    'da': 'Danish',
    'fi': 'Finnish',
    'vi': 'Vietnamese'
  };
  
  return codeToName[code] || code;
};